import { canonicalizeBuiltinAgentControllerRef } from "./agent-controller-ref.js";
import * as z$1 from "zod/v4";
//#region src/schemas/daemon/conversation-contract.ts
const agentControllerConversationKindSchema = z$1.enum([
	"session",
	"thread",
	"context"
]);
const trimmedNonEmptyStringSchema = z$1.string().trim().min(1);
const agentControllerConversationRefSchema = z$1.strictObject({
	agentControllerRef: trimmedNonEmptyStringSchema,
	agentControllerConversationKind: agentControllerConversationKindSchema,
	agentControllerConversationId: trimmedNonEmptyStringSchema
});
const conversationPolicySchema = z$1.strictObject({
	collaborationMode: z$1.enum(["default", "plan"]).optional(),
	fallbackModel: z$1.string().min(1).optional(),
	model: z$1.string().min(1).optional(),
	reasoningLevel: z$1.string().min(1).optional()
});
const BUILTIN_AGENT_CONTROLLER_CONVERSATION_KIND_BY_CONTROLLER_ID = {
	antigravity: "session",
	codex: "thread",
	"claude-code": "session",
	cursor: "session",
	"grok-build": "session",
	openclaw: "session",
	opencode: "session"
};
const BUILTIN_AGENT_CONTROLLER_ALLOWS_DISTINCT_CONVERSATION_ID = { openclaw: true };
const resolveBuiltinAgentControllerConversationKind = (agentControllerRef) => {
	const canonical = canonicalizeBuiltinAgentControllerRef(agentControllerRef);
	if (!canonical) return null;
	const builtinControllerId = canonical.slice(8);
	return BUILTIN_AGENT_CONTROLLER_CONVERSATION_KIND_BY_CONTROLLER_ID[builtinControllerId] ?? null;
};
const builtinAgentControllerAllowsDistinctConversationId = (builtinControllerId) => BUILTIN_AGENT_CONTROLLER_ALLOWS_DISTINCT_CONVERSATION_ID[builtinControllerId] === true;
const buildAgentControllerConversationRef = (input) => ({
	agentControllerRef: input.agentControllerRef,
	agentControllerConversationKind: input.agentControllerConversationKind,
	agentControllerConversationId: input.agentControllerConversationId
});
//#endregion
export { BUILTIN_AGENT_CONTROLLER_ALLOWS_DISTINCT_CONVERSATION_ID, BUILTIN_AGENT_CONTROLLER_CONVERSATION_KIND_BY_CONTROLLER_ID, agentControllerConversationKindSchema, agentControllerConversationRefSchema, buildAgentControllerConversationRef, builtinAgentControllerAllowsDistinctConversationId, conversationPolicySchema, resolveBuiltinAgentControllerConversationKind };

//# sourceMappingURL=conversation-contract.js.map